module.exports = __webpack_public_path__ + "assets/img/98158e5949e9821ef7f6f76df0856e1d.png";